"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import "@local/offer/src/modules/common/lib/cookieScript";
const getConsent = (): boolean => {
  try {
    const state = window.CookieScript?.instance?.currentState?.();
    if (!state) return false;
    if (state.action === "accept") return true;
    if (Array.isArray(state.categories) && state.categories.length > 0) {
      return state.categories.includes("performance");
    }
  } catch (_) {
    // CookieScript not loaded yet
  }
  return false;
};
const applyConsent = () => {
  window.Luigis = window.Luigis || {};
  window.Luigis.cookies_consent = getConsent();
};
export const LuigisBox = () => {
  const $ = _c(1);
  const scriptId = process.env.NEXT_PUBLIC_LUIGI_BOX_LBX_ID;
  if (!scriptId) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script id="luigisbox" src={`https://scripts.luigisbox.tech/${scriptId}.js`} strategy="lazyOnload" crossOrigin="anonymous" onLoad={applyConsent} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};